import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private auths: AuthService, private router: Router) {
  }

  ngOnInit() {
    if (this.auths.isAuthToken()) {
      this.router.navigate(["process-select"])
    }
  }

}
